import { FileExcelOutlined, UploadOutlined } from '@ant-design/icons'
import { Stack, TextColors, Typography } from '@sureco/design-system'
import { Upload } from '@surecompanies/core_components'
import React, { useCallback } from 'react'

interface QuoteFileDropzoneProps {
  file: File | null
  onChange: (file: File) => void
  error?: string
  /** When true the dragger is non-interactive and file swaps are blocked. */
  disabled?: boolean
}

export default function QuoteFileDropzone({
  file,
  onChange,
  error,
  disabled = false,
}: QuoteFileDropzoneProps) {
  const handleBeforeUpload = useCallback(
    (incoming: File) => {
      if (disabled) return false
      onChange(incoming)
      return false
    },
    [onChange, disabled]
  )

  return (
    <Stack space={4}>
      <Upload.Dragger
        accept=".xlsm"
        beforeUpload={handleBeforeUpload}
        disabled={disabled}
        maxCount={1}
        multiple={false}
        openFileDialogOnClick={!disabled}
        showUploadList={false}
        style={
          error
            ? { border: '1px solid #ff4d4f', borderRadius: 8 }
            : disabled
              ? { opacity: 0.5, cursor: 'not-allowed' }
              : undefined
        }
      >
        <Stack space={8} style={{ padding: '16px 0' }}>
          <div style={{ fontSize: 32, color: file ? '#52c41a' : '#8c8c8c' }}>
            {file ? <FileExcelOutlined /> : <UploadOutlined />}
          </div>
          {file ? (
            <>
              <Typography size={14} style={{ fontWeight: 500 }}>
                {file.name}
              </Typography>
              <Typography size={12} color="#8c8c8c">
                Drag and drop or click to replace
              </Typography>
            </>
          ) : (
            <>
              <Typography size={14} style={{ fontWeight: 500 }}>
                Drop the prospect quote file here
              </Typography>
              <Typography size={12} color="#8c8c8c">
                Accepts .xlsm — the "Shoppable" tab will be used to build the
                employee population
              </Typography>
            </>
          )}
        </Stack>
      </Upload.Dragger>
      {error && (
        <Typography size={12} color={TextColors.error}>
          {error}
        </Typography>
      )}
    </Stack>
  )
}
